






import { Component, Vue, Watch } from 'vue-property-decorator';
import BanPolicyForm from '@/components/forms/BanPolicyForm.vue';
import { dispatchGetServiceBanPolicy, readOneServiceBanPolicy } from '@/store/admin/accessors';

@Component({
  components: {
    BanPolicyForm,
  },
})
export default class EditBanPolicy extends Vue {
  public async mounted() {
    await dispatchGetServiceBanPolicy(this.$store, Number(this.$router.currentRoute.params.id));
  }

  public get banPolicy() {
    return readOneServiceBanPolicy(this.$store)(+this.$router.currentRoute.params.id);
  }
}
